"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const i18next_1 = __importDefault(require("i18next"));
const _1 = require(".");
function default_1() {
    (0, _1.copyToClipboard)({
        data: window.location.href,
        message: i18next_1.default.t('클립보드에 주소가 복사되었어요'),
    });
}
exports.default = default_1;
